import { SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionMultimediaFile } from './internal';
import { SelectionRecord } from './base';
export class SelectionMultimediaRecord extends SelectionWithNoteSourceCitationMixin(SelectionRecord) {
    getFileReference() {
        return this.get("FILE" /* Tag.File */, null, SelectionMultimediaFile);
    }
}
//# sourceMappingURL=SelectionMultimediaRecord.js.map